module.exports = __webpack_public_path__ + "img/bianji@3x.43773fe3.svg";